import * as React from "react";
import Cropper from 'react-cropper';
import "cropperjs/dist/cropper.css";
import { api } from "src/services/api";

import Modal from "./Modal";

/* HOW TO USE

import { user } from "src/services/api";
import { route } from "src/services/browser";
import { ImageEditor } from "src/components/ui";

<Modal open={true}>
    <ImageEditor
      save={ route('editImage', {obj: 'user', id: user.id} ) }
      src="https://schoolvisor-2018-progress-roomupstairs.c9users.io/.cache/users-285.100.jpg"
      onClose={() => alert('close') }
    />
</Modal>

*/

interface Props {
    save?: string;
    src?: string;
    updateImg?: string;
    onClose: Function;
    onComplete?: Function;
    ratio?: number;
}

interface State {
    saving?: boolean;
}

export default class ImageEditor extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    
    async save() {
        const { save, updateImg, onComplete } = this.props;
        if (save) {
            this.setState({
                saving: true
            });
            // image in dataUrl
            const imgData = (this.refs.cropper as any).getCroppedCanvas().toDataURL();
            const data = await api( {
              url: save,
              method: 'post',
              rawRespone: true,
              data: {
                imgData
              }
            });
            this.setState({
                saving: false
            });
            const path = data.data;
            if (updateImg) {
                // update dom (sigh...)
                const els = document.querySelectorAll(`[data-edit-img="${updateImg}"]`);
                (els as any).forEach( el => {
                    el.src = path; 
                });
            }
            if (onComplete) {
                onComplete(path);
            }
        }
        this.cancel();
    }
    
    cancel() {
        const { onClose } = this.props;
        if (onClose) {
            onClose();
        }
    }
    
    rotate( degree ) {
        (this.refs.cropper as any).rotate(degree);
    }
  
    render() {
        const { children, src, ratio = 1/1 } = this.props;
        const { saving } = this.state;
        
        return (
          <div className="UI_ImageEditor">
            <Cropper
                ref="cropper"
                src={src}
                style={{height: 400, width: '100%'}}
                // Cropper.js options
                aspectRatio={ratio}
                guides={false}
                //crop={() => this._crop()}
            />
            <nav>
                <div>
                    <span>Ruota</span>
                    <button className="action xs" onClick={() => this.rotate(-90)}><span>A sinistra</span></button>
                    <button className="action xs" onClick={() => this.rotate(90)}><span>A destra</span></button>
                </div>
                <div>
                    <button className="cancel xs" onClick={() => this.cancel()}><span>Annulla</span></button>
                    {saving &&
                    <button className="cancel xs" disabled><span>Salva</span></button>
                    }
                    {!saving &&
                    <button className="main xs" onClick={() => this.save()}><span>Salva</span></button>
                    }
                </div>
            </nav>
          </div>
        );
    }
}

export class ImageEditorToggler extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            open: props.open || false
        };
    }
    
    render() {
        return (
        <>
            {this.state && this.state.open && 
            <Modal open={true} title={"Ritaglia la tua foto"}>
                <ImageEditor {...this.props} onClose={() => this.setState({open: false})} />
            </Modal>
            }
            <span onClick={() => this.setState({open: true}) }>
                {this.props.children}
            </span>
        </>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/ImageEditor.tsx